import ImageUploadControl from 'components/formfields/ImageUploadControl';

import { Stack } from 'react-bootstrap';
import { IMAGE_SIZES } from 'utils/constants';
import { DEFAULT_PANEL_NAME } from '../../constant';
import { DefaultPanelItem } from '../../model';
import './style.scss';
interface DefaultPanelItemProps {
  item: DefaultPanelItem;
  control: any;
  errors: any;
}

const DefaultPanelRows: React.FC<DefaultPanelItemProps> = ({ item, control, errors }) => {
  const fieldName = `image_${item.id}`;
  const currentImageError = errors[fieldName];

  let minWidth: number;
  let minHeight: number;
  let maxWidth: number;
  let maxHeight: number;
  let maxFileSize: number;
  let style: React.CSSProperties | undefined;
  switch (item.type) {
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_1X1:
      minWidth = IMAGE_SIZES.default_panel_image_w1_h1_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w1_h1_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w1_h1_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w1_h1_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w1_h1_size.maxFileSize;
      style = { maxWidth: '100px' };
      break;
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_1X2:
      minWidth = IMAGE_SIZES.default_panel_image_w1_h2_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w1_h2_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w1_h2_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w1_h2_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w1_h2_size.maxFileSize;
      style = { maxWidth: '100px' };
      break;
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_2X1:
      minWidth = IMAGE_SIZES.default_panel_image_w2_h1_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w2_h1_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w2_h1_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w2_h1_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w2_h1_size.maxFileSize;
      style = { maxWidth: '200px' };
      break;
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_3X1:
      minWidth = IMAGE_SIZES.default_panel_image_w3_h1_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w3_h1_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w3_h1_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w3_h1_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w3_h1_size.maxFileSize;
      style = { maxWidth: '400px' };
      break;
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_2X2:
      minWidth = IMAGE_SIZES.default_panel_image_w2_h2_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w2_h2_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w2_h2_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w2_h2_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w2_h2_size.maxFileSize;
      style = { maxWidth: '200px' };
      break;
    case DEFAULT_PANEL_NAME.DEFAULT_PANEL_TYPE_IMAGE_3X2:
      minWidth = IMAGE_SIZES.default_panel_image_w3_h2_size.minWidth;
      minHeight = IMAGE_SIZES.default_panel_image_w3_h2_size.minHeight;
      maxWidth = IMAGE_SIZES.default_panel_image_w3_h2_size.maxWidth;
      maxHeight = IMAGE_SIZES.default_panel_image_w3_h2_size.maxHeight;
      maxFileSize = IMAGE_SIZES.default_panel_image_w3_h2_size.maxFileSize;
      style = { maxWidth: '400px' };
      break;
    default:
      minHeight = 0;
      minWidth = 0;
      maxWidth = 0;
      maxHeight = 0;
      maxFileSize = 0;
      style = undefined;
      break;
  }

  return (
    <tr key={fieldName}>
      <td className="text-center" style={{ width: '10%', backgroundColor: '#36489a', color: '#fff' }}>
        {item.type}
      </td>

      <td>
        <Stack style={{ position: 'relative' }}>
          <div>
            {currentImageError && (
              <small
                className="text-danger d-inline-block mt-2"
                style={{
                  position: 'absolute',
                  zIndex: 10,
                }}
              >
                {currentImageError.message}
              </small>
            )}
            <ImageUploadControl
              name={fieldName}
              minWidth={minWidth}
              minHeight={minHeight}
              maxWidth={maxWidth}
              maxHeight={maxHeight}
              maxFileSize={maxFileSize}
              control={control}
              style={style}
            ></ImageUploadControl>
          </div>
        </Stack>
      </td>
    </tr>
  );
};

export default DefaultPanelRows;
